// extracted by mini-css-extract-plugin
module.exports = {"divOrder":"OrderBy_divOrder__1ERyZ","label":"OrderBy_label__3IUo7"};